// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { documentsStyles } from "@eisinc/Overrides/Widgets/ProductDetails/ProductDetailsDocuments";
import LinkFileInactive from "@eisinc/XDL/Icons/LinkFileInactive";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

documentsStyles.wrapper = {
    css: css`
        padding: 0;
    `,
};

documentsStyles.container = {
    gap: 24,
};

documentsStyles.titleStyles = {
    variant: "h2",
    forwardAs: "p",
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        padding-bottom: 7px;
    `,
};

documentsStyles.documentGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

documentsStyles.typeTitle = {
    variant: "h4",
    forwardAs: "p",
    css: css`
        margin-bottom: 12px;
    `,
};

documentsStyles.pfdStyles = {
    documentLink: {
        typographyProps: {
            css: css`
                align-items: flex-start;
            `,
        },
        css: css`
            width: 100%;
            justify-content: center;
            margin-bottom: 16px;

            :last-child {
                margin: 0;
            }

            @media (max-width: 768px) {
                justify-content: flex-start;
            }
        `,
    },
    documentIcon: {
        src: LinkFileInactive,
        color: "text.link",
        width: 12,
        height: 16,
    },
    documentNameText: {
        weight: fontConfig.weight.medium,
        size: fontConfig.regular.size,
        lineHeight: fontConfig.singleLineRegular.lineHeight,
        color: "text.link",
    },
};
